//import React, { useState, useEffect, useContext } from 'react'
//import { useTranslation } from 'react-i18next'
//import { createMarkup, setParams } from './utils'
//import { apiDefaults, apiFetch, parseJSON } from  './api'
//import Loading from './components/Loading/Loading'
//import Item from './Item'
//import './CategoryInfo.css'
//import history from './history'
//
//const CategoryInfo = ({catID}) => {
//  const [item, setItem] = useState(undefined)
//  const [isLoading, setIsLoading] = useState(true)
//  const { t } = useTranslation()
//
//  const fetchContent = async(controller) => {
//    setIsLoading(true)
//    const url = new URL(`${apiDefaults.project}/items/ic1ty_categories`, apiDefaults.url)
//    //const url = new URL(`/categories`, apiDefaults.url)
//
//    const params = [
//      [`filter[id][eq]`, `${catID}`],
//    ]
//    
//    setParams(url, params)
//
//    const response = await apiFetch(url, controller.signal)
//    const json = await response.json()
//    setItem(json.data)
//    setIsLoading(false)
//  }
//
//  useEffect(() => {
//    const myController = new AbortController();
//    fetchContent(myController)
//    return () => myController.abort()
//  }, [catID])
//
//  const wrapperRef = React.useRef(null)
//
//  const itemRef = React.useCallback(node => {
//    if (node !== null) {
//      const itemLinks = node.querySelectorAll('a')
//
//      itemLinks.forEach(itemLink => itemLink.addEventListener('click', handleTextLinkClick))
//    }
//  })
//
//  const handleTextLinkClick = (e) => {
//      e.preventDefault()
//      const appOrigin = window.location.origin
//      const appHostname = window.location.hostname
//      const appPathname = window.location.pathname
//      const linkOrigin = e.target.origin
//      const linkHostname = e.target.hostname
//      const linkPathname = e.target.pathname
//      const linkHash = e.target.hash
//
//      if (linkHash.length > 0 && (appOrigin + appPathname === linkOrigin + linkPathname)) {
//        const hashTargetElement = document.getElementById(linkHash.substr(1))
//        hashTargetElement ? hashTargetElement.scrollIntoView({block: 'start', behavior: 'smooth'}) : wrapperRef.current.scrollIntoView({block: 'end', behavior: 'smooth'})
//        return
//      }
//
//      if (linkHostname === appHostname) {
//        const pathname = e.target.pathname
//        const nextLocation = {
//          pathname
//        }
//
//        history.push(nextLocation)
//
//        return
//      }
//
//      window.location.href = e.target.href
//  }
//
//    if (isLoading) {
//        return <Loading/>
//    }
//
//    if (item) {
//        return (
//          <div className="CategoryInfo" ref={wrapperRef}>
//            <h1>{item[0].title}</h1>
//            <div ref={itemRef} dangerouslySetInnerHTML={{__html: item[0].description}}></div>
//          </div>
//        )
//    }
//}
//
//export default CategoryInfo



import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { createMarkup, setParams } from './utils'
import { apiDefaults, apiFetch, parseJSON } from  './api'
import Loading from './components/Loading/Loading'
import Item from './Item'
import './CategoryInfo.css'
import history from './history'
import useAxios from 'axios-hooks'

const CategoryInfo = ({catID}) => {
  const [item, setItem] = useState(undefined)
  const [isLoading, setIsLoading] = useState(true)
  const { t } = useTranslation()

  const [{ data, loading, error }, executeAxios] = useAxios(
    {
      url: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}/category/${catID}`,
      method: 'GET',
      withCredentials: true,
    }
  )

  const wrapperRef = React.useRef(null)

  const itemRef = React.useCallback(node => {
    if (node !== null) {
      const itemLinks = node.querySelectorAll('a')

      itemLinks.forEach(itemLink => itemLink.addEventListener('click', handleTextLinkClick))
    }
  })

  const handleTextLinkClick = (e) => {
      e.preventDefault()
      const appOrigin = window.location.origin
      const appHostname = window.location.hostname
      const appPathname = window.location.pathname
      const linkOrigin = e.target.origin
      const linkHostname = e.target.hostname
      const linkPathname = e.target.pathname
      const linkHash = e.target.hash

      if (linkHash.length > 0 && (appOrigin + appPathname === linkOrigin + linkPathname)) {
        const hashTargetElement = document.getElementById(linkHash.substr(1))
        hashTargetElement ? hashTargetElement.scrollIntoView({block: 'start', behavior: 'smooth'}) : wrapperRef.current.scrollIntoView({block: 'end', behavior: 'smooth'})
        return
      }

      if (linkHostname === appHostname) {
        const pathname = e.target.pathname
        const nextLocation = {
          pathname
        }

        history.push(nextLocation)

        return
      }

      window.location.href = e.target.href
  }

  if (error) {
    if (error.response.status === 401) {
      return <div>Pro zobrazení tohoto obsahu se musíte přihlásit</div> 
    }

    return <div>Chyba zobrazení, chybu jsme zaznamenali</div> 
  }

    if (loading) {
        return <Loading/>
    }

    if (data) {
        return (
          <div className="CategoryInfo" ref={wrapperRef}>
            <h1>{data.title}</h1>
            <div ref={itemRef} dangerouslySetInnerHTML={{__html: data.description}}></div>
          </div>
        )
    }
}

export default CategoryInfo
